import FabricAnalyticsListeners, { FabricChannel } from '@atlaskit/analytics-listeners';
import React from 'react';
import styled from 'styled-components';

import { useFabricAnalyticsListenerAdapter } from '../../../../hooks/useFabricAnalyticsListener';
import Switcher from '../../../Switcher';

const MenuContainer = styled.div`
  max-width: 100vw;
  max-height: calc(100vh - 100px);
  min-height: 200px;
  padding: 0;
`;

const SwitcherMenu = () => {
  const fabricAnalyticsListener = useFabricAnalyticsListenerAdapter();

  return (
    <MenuContainer>
      <FabricAnalyticsListeners
        client={fabricAnalyticsListener}
        excludedChannels={[FabricChannel.atlaskit, FabricChannel.elements, FabricChannel.editor, FabricChannel.media]}
      >
        <Switcher />
      </FabricAnalyticsListeners>
    </MenuContainer>
  );
};

export default SwitcherMenu;
